import * as yup from 'yup';

export const CreateVacancyFormValidation = yup.object().shape({
    idDepartament: yup.string().required('Departamento é obrigatório.'),
    idFaculty: yup.string().required("Unidade orgânica é obrigatória."),
    idCourse: yup.string().required("Curso é obrigatório."),
    numberOfVacancies: yup.number().typeError('Deve ser número').min(1,"Minimo de uma vaga").required("Obrigatória"),
});